import React from 'react';
import { Link } from "gatsby";

const NavLink = ({ currentPath, menuItem, setOpen }) => {

    if(currentPath === menuItem.url) {
        return(
            <span
                className="nav-link"
                onClick={ e => { setOpen(false) } } 
                title={ menuItem.label }
            >
                { menuItem.label }
            </span>
        )
    }else{
        return(
            <Link
                className="nav-link"
                title={ menuItem.label }
                to={ menuItem.url }
            >
                { menuItem.label }
            </Link>
        )
    }
}

export default NavLink;